import { Component, h, Host, Prop, Listen, State } from "@stencil/core";
import { debounce } from "../../utils/debounce";
import { desktopBreakpoint } from "../navigation/shared-variables";

@Component({
    tag: "ux-iws-header",
    styleUrl: "header.scss",
    shadow: false,
})
export class Header {
    private baseClass: string = "ux-iws-header";
    private baseElement: HTMLElement = document.querySelector(this.baseClass);
    private metaAsyncItemsDropdown: NodeListOf<HTMLElement> | null = null;
    private metaAsyncItemsHeader: NodeListOf<HTMLElement> | null = null;

    /** Type of header */
    @Prop() type: string = "trumpf";

    @State() isLocaleSelectionOpen: boolean = false;

    @Listen("uxNavigationLocaleSelection", { target: "window" })
    onLocaleSelectionOpen(e: CustomEvent) {
        this.isLocaleSelectionOpen = e.detail.isOpen;
    }

    componentDidLoad() {
        this.initStaticElements();
        this.resizer();
        window.addEventListener("resize", this.resizer);
    }

    private initStaticElements = () => {
        this.metaAsyncItemsDropdown = this.baseElement.querySelectorAll(
            ".ux-iws-header__meta-container-dropdown ux-iws-async-html"
        );
        this.metaAsyncItemsHeader = this.baseElement.querySelectorAll(
            ".ux-iws-nav__meta-container-header ux-iws-async-html"
        );
    };

    /**
     * browser resizing
     * used for responsive async request
     * debounced resizer -> 100ms
     */
    private resizer = debounce(() => {
        if (window.innerWidth < desktopBreakpoint) {
            this.changeDataSrcAttributes(this.metaAsyncItemsDropdown);
        } else {
            this.changeDataSrcAttributes(this.metaAsyncItemsHeader);
        }
    }, 100);

    /**
     * Change data-src attributes to src attributes
     */
    private changeDataSrcAttributes = (items) => {
        if (items.length) {
            Array.from(items).forEach((item: HTMLElement) => {
                if (item.getAttribute("data-src") !== null) {
                    const dataSrc = item.getAttribute("data-src");
                    item.removeAttribute("data-src");
                    item.setAttribute("src", dataSrc);
                }
            });
        }
    };

    render() {
        return (
            <Host
                class={{
                    [this.baseClass]: true,
                    [`${this.baseClass}--${this.type}`]: true,
                    [`${this.baseClass}--locale-selection-open`]: this
                        .isLocaleSelectionOpen,
                }}
            >
                <header>
                    <slot name="locale-selection" />
                    <slot name="header" />
                    <slot name="breadcrumb-navigation" />
                    <slot name="header-dropdown" />
                </header>
            </Host>
        );
    }
}
